import { SortDirection } from '@angular/material/sort';

import { BaseListFilter } from '../../../models/base-list-filter.model';
import { BrokerApiTestAccountEnum } from './broker-api-test-account.enum';
import { BrokerAPIUserIntegrationTypeEnum } from './broker-api-user-integration-type.enum';
import { BrokerAPIUserStatusEnum } from './broker-api-user-status.enum';

export class BrokerUsersFilter extends BaseListFilter {
  search?: string;
  searchByName?: string;
  searchByEmail?: string;
  searchByTestAccount?: BrokerApiTestAccountEnum;
  status? = BrokerAPIUserStatusEnum.Active;
  integrationType?: BrokerAPIUserIntegrationTypeEnum;
  integrationId?: number;
  integrationName?: string;
  brokerId?: number;

  constructor(
    public sortBy: string = 'id',
    public sortDirection: SortDirection = 'desc',
  ) {
    super();
  }
}
